module.exports = __webpack_public_path__ + "img/TV_android-series_X9500G.52b27eb4.png";